import React, { FC } from "react";
import { IFormItem, ISelectOption } from "../Types";
import { Form, Select, Tooltip } from "antd";

export const __FormSelect: FC<IFormItem> = (props) => {
    const title = <span style={{ cursor: "pointer" }} onClick={(e) => { e.stopPropagation(); props?.copyText?.(props.fieldName, props.options) }}>复制</span>
    return (
        <Form.Item
            // label={props.fieldLabel}
            // label={<Tooltip title={title}>{props.fieldLabel}</Tooltip>}
            label={props.fieldLabel}
            name={props.name ?? props.fieldName}
            rules={props.rules}
            hidden={props.hidden}
            labelCol={props.labelCol}
        >
            <Select
                allowClear={props.allowClear}
                // allowClear
                showSearch={props.showSearch}
                options={props.options}
                disabled={props.disable}
                mode={props.mode}
                optionFilterProp="label"
                onChange={(value: string, option) => props.onSelectChange?.(value, option as ISelectOption)}
                onFocus={() => props.onSelectFocus?.()}

            />
        </Form.Item>
    )
}